import { queryOptions } from "@tanstack/react-query";
import { apiGet } from "@softmax/observatory-client/client";
import type { Schemas } from "@softmax/observatory-client/types";

export const actualViewerQueryOptions = () =>
  queryOptions({
    queryKey: ["viewer", "actual", { elevatedPrivileges: true }],
    queryFn: ({ signal }) =>
      apiGet<Schemas["WhoAmIResponse"]>("/whoami", {
        elevatedPrivileges: true,
        signal,
      }),
    staleTime: 30_000,
  });
